import { api } from 'data/api/api'

import { SendRefundOfferArgs, SendRefundOfferResp } from '../types/refund-offer'

export const sendRefundOffer = ({ complaintId, refundOffer }: SendRefundOfferArgs) =>
  api.post<SendRefundOfferResp>('/refund_offers', {
    complaint_id: complaintId,
    refund_offer: { amount: refundOffer.amount, currency_code: refundOffer.currencyCode },
  })
